import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import logo from '../logo-dot.png';
import './Footer.scss';


// Routes where the footer should collapse to a single thin utility row.
// Keeps the user inside the conversion / auth funnel by hiding marketing
// nav columns that would otherwise bounce them out of the flow.
const MINIMAL_ROUTE_PREFIXES = [
  '/start',
  '/subscription',
  '/signin',
  '/password',
];

const isMinimalRoute = (pathname) =>
  MINIMAL_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );


const MinimalFooter = () => (
  <footer className="Footer Footer--minimal">
    <div className="Footer__minimalInner">
      <span className="Footer__copy">&copy; 2026 Wabi</span>
      <div className="Footer__minimalLinks">
        <Link to="/terms">Terms</Link>
        <Link to="/privacy">Privacy</Link>
        <a href="mailto:hello@meetwabi.com">Contact</a>
      </div>
    </div>
  </footer>
);


const FullFooter = () => (
  <footer className="Footer">
    <div className="Footer__inner">
      <div className="Footer__brand">
        <Link to="/" className="Footer__logo no-style">
          <img src={logo} alt="Wabi" />
        </Link>
        <p className="Footer__tagline">
          Stop paper junk mail — done for you.
        </p>
        <a
          className="Footer__contact"
          href="mailto:hello@meetwabi.com"
        >
          hello@meetwabi.com
        </a>
      </div>

      <nav className="Footer__nav" aria-label="Footer">
        <div className="Footer__col">
          <h4 className="Footer__colHeading">Product</h4>
          <ul>
            <li><a href="/#how-it-works">How it works</a></li>
            <li><a href="/#faqs">FAQs</a></li>
            <li><Link to="/start/step1">Get started</Link></li>
          </ul>
        </div>

        <div className="Footer__col">
          <h4 className="Footer__colHeading">Company</h4>
          <ul>
            <li><a href="/path/">Blog</a></li>
            <li>
              <a href="mailto:hello@meetwabi.com">Contact</a>
            </li>
            <li><Link to="/sitemap">Sitemap</Link></li>
          </ul>
        </div>

        <div className="Footer__col">
          <h4 className="Footer__colHeading">Legal</h4>
          <ul>
            <li><Link to="/terms">Terms</Link></li>
            <li><Link to="/privacy">Privacy</Link></li>
          </ul>
        </div>
      </nav>
    </div>

    <div className="Footer__bottom">
      <span>&copy; 2026 Wabi. All rights reserved.</span>
      <span className="Footer__madeWith">
        Helped save 20,166+ trees and counting.
      </span>
    </div>
  </footer>
);


const Footer = () => {
  const location = useLocation();
  return isMinimalRoute(location.pathname) ? <MinimalFooter /> : <FullFooter />;
};

export default Footer;
